import { api } from '_api';

import type { Finder, Mutator } from '_types/swr';

import { unwrap } from '_utils/axios';
import { parseKey } from '_utils/swr';
import { Attendance } from '_types/models/Attendance';
import { NoContent } from '_types';
import { EndAttendance, NpsAttendance } from '_types/requests/Client/attendance';
import { GeneratedChatToken } from '_types/responses/generated-chat-token';

export const findAttendance: Finder<Attendance> = async ({ queryKey }) => {
    const url = parseKey(queryKey);
    const response = await api.get<Attendance>(url);

    return await unwrap(response);
};


export const endAttendance: Mutator<NoContent, EndAttendance> = async (queryKey, payload) => {

    const url = parseKey(queryKey);
    const response = await api.post<NoContent>(url, payload);
    return await unwrap(response);
}

export const npsAttendance: Mutator<NoContent, NpsAttendance> = async (queryKey, payload) => {

    const url = parseKey(queryKey);
    const response = await api.post<NoContent>(url, payload);
    return await unwrap(response);
}

export const chatToken: Mutator<GeneratedChatToken> = async (queryKey, payload) => {

    const url = parseKey(queryKey);
    const response = await api.post<GeneratedChatToken>(url, payload);
    return await unwrap(response);
}
